module.exports = __webpack_public_path__ + "static/media/frame_person.43101bd7.svg";